











































import { Prop, Mixins, Component, Watch, Ref } from "vue-property-decorator";
import CompanyMixin from "@/mixins/http/Company";
import LogoWithFallback from "@/components/LogoWithFallback.vue";
import { Company } from "@/models";
import ColorHelper from "@/services/ColorHelper";

const REQUEST_TAG = "companies";
const MIN_REQUEST = 3;
const DELAY = 750;

@Component({ components: { LogoWithFallback } })
export default class AdminCompanySelect extends Mixins(CompanyMixin) {
  @Prop({ default: null }) readonly value!: Company | null;

  selected: Company | null = null;
  companies: Company[] = [];
  color: string | undefined = undefined;
  showDrop = false;
  timeout = 0;
  loading = false;
  @Ref() readonly searchTerm!: HTMLInputElement;
  term = "";

  async onInputClick() {
    this.showDrop = true;
    await this.$nextTick();
    this.searchTerm.focus();
  }

  getColor(company: Company): string {
    if (typeof this.color == "string") {
      return this.color;
    } else {
      return this.color
        ? ColorHelper.colorAtIndex(this.color)
        : ColorHelper.pickForKey(company.id);
    }
  }

  onClickOutside() {
    this.showDrop = false;
  }

  async onCompanyClick(company: Company) {
    this.selected = company;
    this.showDrop = false;
    this.term = "";
    this.companies = [];
    this.$emit("input", company);
  }

  get selectedCompany() {
    return this.selected == null ? "" : this.selected.name;
  }

  async search() {
    this.loading = true;
    this.companies = await this.getCompanies(
      { filter: { name: `${this.term}%` } },
      REQUEST_TAG
    );
    this.loading = false;
  }

  mounted() {
    if (this.value) {
      this.selected = this.value.clone();
    }
  }

  @Watch("term")
  onTermChange(value: string | null) {
    if (value && value.length > MIN_REQUEST) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.search();
      }, DELAY);
    } else {
      this.companies = [];
    }
  }
}
